"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _BaseRenderer = _interopRequireDefault(require("./BaseRenderer"));

var _LayerRenderer2 = _interopRequireDefault(require("./LayerRenderer"));

var _TextCreativeLayer = _interopRequireDefault(require("../../models/creative/TextCreativeLayer"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var TextRenderer = /*#__PURE__*/function (_LayerRenderer) {
  (0, _inherits2["default"])(TextRenderer, _LayerRenderer);

  var _super = _createSuper(TextRenderer);

  function TextRenderer(creativeLayer, contentStore, layerTransformer, filterProcessor) {
    var _this;

    (0, _classCallCheck2["default"])(this, TextRenderer);

    if (!_TextCreativeLayer["default"].isTextCreativeLayer(creativeLayer)) {
      throw new Error('Must be initialized with a creative layer of the content type TEXT');
    }

    _this = _super.call(this, creativeLayer, contentStore, layerTransformer, filterProcessor);
    _this._contentScaleMode = _BaseRenderer["default"].SCALE_MODE_OVERFLOW;
    return _this;
  }

  return TextRenderer;
}(_LayerRenderer2["default"]);

exports["default"] = TextRenderer;